import { gql } from '@apollo/client';

export const GET_SITES = gql`
  query GetSites($filter: SiteFilter, $sorting: [SiteSort!]) {
    sites(filter: $filter, sorting: $sorting) {
      id
      name
      sourceName
      sourceId
      siteAvailabilityControl
      siteLimits {
        start
        nameplateMaxImportPower
        nameplateMaxExportPower
        contractualMaxImportPower
        contractualMaxExportPower
        contractualEnergyCapacity
        gridConnectionMaxImportPower
        gridConnectionMaxExportPower
      }
      assets {
        name
        sourceName
        sourceId
        assetLimits {
          id
          start
          nameplateMaxImportPower
          nameplateMaxExportPower
          nameplateEnergyCapacity
        }
      }
    }
  }
`;

export const GET_SITE_AVAILABILITIES = gql`
  query GetSiteAvailabilities(
    $filter: SiteAvailabilityFilter
    $sorting: [SiteAvailabilitySort!]
  ) {
    siteAvailabilities(filter: $filter, sorting: $sorting) {
      id
      start
      end
      maxImportPower
      maxExportPower
      energyCapacity
      siteAvailabilityReason
      notes
      isCancelled
      createdAt
      sourceName
      sourceId
      updatedByUserAt
    }
  }
`;

export const GET_SITE_AVAILABILITY = gql`
  query GetSiteAvailability($id: Int!) {
    siteAvailability(id: $id) {
      id
      start
      end
      siteAvailabilityReason
      notes
      createdAt
      updatedAt
      isCancelled
      cancelledAt
      createdByUserEmail
      updatedByUserEmail
      updatedByUserAt
      sourceName
      sourceId
      maxImportPower
      maxExportPower
      energyCapacity
    }
  }
`;

export const GET_SITE_AVAILABILITY_AUDITS = gql`
  query GetSiteAvailabilityAudits($siteAvailabilityId: ID!) {
    siteAvailabilityAudits(siteAvailabilityId: $siteAvailabilityId) {
      action
      updatedByUserEmail
      updatedAt
      updatedValue {
        maxImportPower
        maxExportPower
        energyCapacity
        createdByUserEmail
        start
        end
        notes
        siteAvailabilityReason
        isCancelled
        updatedByUserAt
      }
    }
  }
`;

export const GET_ASSET_AVAILABILITIES = gql`
  query GetAssetAvailabilities(
    $filter: AssetAvailabilityFilter
    $sorting: [AssetAvailabilitySort!]
  ) {
    assetAvailabilities(filter: $filter, sorting: $sorting) {
      id
      start
      end
      maxImportPower
      maxExportPower
      energyCapacity
      assetAvailabilityReason
      notes
      isCancelled
      createdAt
      sourceName
      sourceId
      updatedByUserAt
      asset {
        id
        name
        sourceName
        sourceId
      }
    }
  }
`;

export const GET_ASSET_AVAILABILITY = gql`
  query GetAssetAvailability($id: Int!) {
    assetAvailability(id: $id) {
      id
      start
      end
      assetAvailabilityReason
      notes
      createdAt
      updatedAt
      isCancelled
      cancelledAt
      createdByUserEmail
      updatedByUserEmail
      updatedByUserAt
      sourceName
      sourceId
      maxImportPower
      maxExportPower
      energyCapacity
      asset {
        id
        name
        sourceName
        sourceId
      }
    }
  }
`;

export const GET_ASSET_AVAILABILITY_AUDITS = gql`
  query GetAssetAvailabilityAudits($assetAvailabilityId: ID!) {
    assetAvailabilityAudits(assetAvailabilityId: $assetAvailabilityId) {
      action
      updatedByUserEmail
      updatedAt
      updatedValue {
        maxImportPower
        maxExportPower
        energyCapacity
        createdByUserEmail
        start
        end
        notes
        assetAvailabilityReason
        isCancelled
        updatedByUserAt
      }
    }
  }
`;
